import { CREATE_EXPERIENCE, REMOVE_EXPERIENCE } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const experiences = (state=loadFromLocalStorage(CREATE_EXPERIENCE, []), action) =>{
    const {type, payload} = action;

    switch(type){
        case CREATE_EXPERIENCE:{
            const {experience} = payload;
            const newExperience = {
                experience,
            };
            const updatedState = state.concat(newExperience);
            saveToLocalStorage(CREATE_EXPERIENCE, updatedState);
            return updatedState;
        }
        case REMOVE_EXPERIENCE: {
            const {experience} = payload;
            const updatedState = state.filter(obj => obj.experience !== experience);
            saveToLocalStorage(REMOVE_EXPERIENCE, updatedState);
            return updatedState;
        }
        default: 
            return state;
    }
}